var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full relative"},[_c('StandardLights'),(_vm.game && _vm.camlocker)?_c('EventGUI',{attrs:{"game":_vm.game,"camlocker":_vm.camlocker}}):_vm._e(),_c('LoadingGUI')],1)}
var staticRenderFns = []

export { render, staticRenderFns }